import React, { useEffect, useState } from 'react'
import Breadcrum from '../../../components/common/Breadcrum'
import Models from '../../../components/common/Models'
import { toast } from "react-toastify";
import Spinner from "../../../components/loader/Spinner";
import BasicTableOne from "../../../components/table/BasicTable";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from 'react-redux';
import { adminDelete, createAdmin, editAdmin, adminStatusUpdate, getAllAdmin, adminResetPassword } from '../../../redux/slices/adminSlice';
import { getActiveCenter } from '../../../redux/slices/centersSlice';
import store from '../../../redux/store';
import Input from '../../../components/form/Input';
import Select from '../../../components/form/Select';
import { selectResponse } from '../../../Helpers/common';
export default function SuperAdminAdmin() {
    const [isOpen, setIsOpen] = React.useState(false)
     const [tableRow, setTableRow] = useState([]);
      const [tableColumns, setTableColumns] = useState([]);
      const [editData, setEditData] = useState(null);
      const [pageAction, setPageAction] = useState("create");
        const dispatch = useDispatch();
    const [formData, setFormData] = React.useState({
        name: "",
        email:"",
        phone: "",
        fk_instituteCenter_id: "",
        centers: []
      });
      
    // Function to reset form data and close modal
    const handleCloseModal = () => {
      setFormData({
        name: "",
        email: "",
        phone: "",
        fk_instituteCenter_id: "",
        centers: []
      });
      setPageAction("create");
      setIsOpen(false);
    };
      
    const breadcrumbItems = [
        { label: 'Admins', path: '/super-admin/admins' }      ];
      
      const { admins = [], adminLoading: adminLoading } = useSelector(
    (state) => state?.admin || {}
  );
  console.log("admins", admins);
    const { centers = [], centerLoading: centerLoading } = useSelector(
        (state) => state?.centers || {}
    );
  useEffect(() => {
    dispatch(getActiveCenter());
    
    // Fetch admins and log the state before and after
    console.log("Before fetching admins - Redux state:", store.getState().admin);
    dispatch(getAllAdmin()).then(action => {
      console.log("getAllAdmin action result:", action);
      console.log("After fetching admins - Redux state:", store.getState().admin);
    });
  }, [dispatch]);

       useEffect(() => {
      setTableColumns([
        { id: "id", label: "#", type: "text" },
        { id: "name", label: "Name", type: "text" },
        { id: "email", label: "Email", type: "text" },
        { id: "phone", label: "Phone", type: "text" },        { 
          id: "status", 
          label: "Status", 
          type: "boolean",
          actions: ["toggleStatus"] 
        },
        {
          id: "action",
          label: "Action",
          type: "action",
          actions: ["resetPassword", "edit", "delete"],
        },
      ]);
      setTableRow(admins);
      if (admins.length > 0) {
        const updatedRows = admins.map((admin, index) => ({
          id: index + 1,
          name: admin.name,
          email: admin.email || "N/A",
          phone: admin.phone || "N/A",
          status: admin.status,
          uuid: admin.id,
        }));
        setTableRow(updatedRows);
      }
    }, [admins]);

    const handleSubmit = async (e) => {
      e.preventDefault();
      let data = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        fk_instituteCenter_id: formData.fk_instituteCenter_id,
      };
        try {
        let response;
        if (pageAction === "edit") {
          response = await dispatch(editAdmin({ id: formData.id, ...data })).unwrap();
        } else {
          response = await dispatch(createAdmin(data)).unwrap();
        }
          if (response?.status === "success") {
          toast.success(pageAction === "edit" ? "Admin updated successfully!" : "Admin created successfully!");
          handleCloseModal();
          
          // Force refresh of admin list after creating
          if(pageAction === "edit") {
          setTableRow((prevRows) =>
            prevRows.map((row) =>
              row.uuid === formData.id
                ? { ...row, name: formData.name, email: formData.email, phone: formData.phone }
                : row
            )
          );
        }else{
          dispatch(getAllAdmin());

        }
        } else {
          toast.error(pageAction === "edit" ? "Failed to update admin" : "Failed to create admin");
        }
      } catch (error) {
        console.error("Error in admin creation:", error); // Better error logging
        toast.error(error?.message ?? "Something went wrong");
      }
    };  
    const handleTableAction = (action, row) => {
    console.log("Action:", action, "Row:", row);

    switch (action) {
      case "edit":
        console.log("Editing row:", row);
        // Find the full admin data from the admins array
        const adminToEdit = admins.find(admin => admin.id === row.uuid);
        if (adminToEdit) {
          setFormData({
            id: adminToEdit.id,
            name: adminToEdit.name,
            email: adminToEdit.email,
            phone: adminToEdit.phone,
            fk_instituteCenter_id: adminToEdit.fk_instituteCenter_id,
          });
          setIsOpen(true);
          setPageAction("edit");
        } else {
          toast.error("Admin data not found for editing");
        }
        break;
      case "delete":
         Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            (async () => {
              try {
                await dispatch(adminDelete({ id: row.uuid })).unwrap();
                setTableRow((prevRows) =>
                  prevRows.filter((r) => r.uuid !== row.uuid)
                );
              toast.success("admin deleted successfully!");
              } catch (error) {
                toast.error(`Failed to delete admin: ${error.message}`);
              }
            })();
          }
        });
        break;
      case "resetPassword":
        // Navigate to details page
        console.log("Resetting password for:", row);
        Swal.fire({
          title: "Reset Password",
          text: "Are you sure you want to reset the password?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, reset it!",
          cancelButtonText: "No, cancel!"
        }).then((result) => {
          if (result.isConfirmed) {
            (async () => {
              try {
                await dispatch(adminResetPassword({ id: row.uuid })).unwrap();
                toast.success("Password reset successfully!");
              } catch (error) {
                toast.error(`Failed to reset password: ${error.message}`);
              }
            })();
          }
        });
        break;
        case "toggleStatus":
                (async () => {
                  try {
                   await dispatch(adminStatusUpdate({ id: row.uuid, status: row.status })).unwrap();
                    toast.success(`admin status updated successfully!`);
                  } catch (error) {
                    toast.error(`Failed to update admin status: ${error.message}`);
                  } 
                })();
                break;
      default:
        console.log("Unhandled action:", action);
    }
  };
  return (
   <>
   <div className='bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center'>
   <div>
    <h1 className='text-2xl font-semibold text-theme-dark dark:text-theme-light'>{breadcrumbItems[0].label}</h1>
   <Breadcrum items={breadcrumbItems}  />
   </div>
   <div>    <button onClick={() => setIsOpen(true)} className='bg-primary-light text-white px-3 py-2 rounded-xl'>Add New Admin</button>
   </div>
    
   <Models isOpen={isOpen} isClose={handleCloseModal} name={pageAction === "edit" ? "Edit Admin" : "Add New Admin"} >
       {/* Add your form or content for adding a new admin here */}
       <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Name"
          value={formData.name}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, name: e.target.value }))
          }
          required
        />
        <Input
          label="Email"
          value={formData.email}
          type="email"
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, email: e.target.value }))
          }
          required
        />
        <Input
          label="Phone"
          value={formData.phone}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, phone: e.target.value }))
          }
          required
        />
            <Select
              label="Center"
              options={selectResponse(centers)}
              value={formData.centers}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, fk_instituteCenter_id: value }))
              }     
              isDisabled={centerLoading}
            />
              <button
                type="submit"
                className="bg-primary-light w-full text-white px-3 py-2 rounded-xl"
                
              >
               {
                pageAction === "edit" ? "Update Admin" : "Create Admin"
               }
              </button>
       </form>
   </Models>
   </div>
     <div className="mt-4 ">
           <BasicTableOne
             tableColumns={tableColumns}
             handleTableAction={handleTableAction}             tableRows={tableRow}
             title="Admins"
             loading={adminLoading}
           />
         </div>
   </>
  )
}
